import { Injectable } from '@angular/core';
import AES from 'crypto-js/aes';
import { ConfigService } from './_service/config.service';

const SECURE_BYTE_LENGTH = 32;
const HEX_RADIX = 16;
const HEX_PADDING_LENGTH = 2;
const UID_RANDOM_HEX_LENGTH = 12;

@Injectable({
  providedIn: 'root'
})

export class ViewSupplierServiceService {

  constructor(public  configService: ConfigService){ }
  createToken() {
    const dataConfig = this.configService.getConfig();
    if (!dataConfig || !Array.isArray(dataConfig) || dataConfig.length === 0) {
      throw new Error('Invalid configuration data');
    }
    const payload = {
      cid: dataConfig[0].OIDC_CLIENT_ID,
      username: 'supplier',
      uid:this.generateUid(),
      roles: ['supplier']
    };

    const jsonData = JSON.stringify(payload);
    const encryptedData = AES.encrypt(jsonData, dataConfig[0].OIDC_CLIENT_ID).toString();

    return encryptedData;
  }
  generateUid(): string {
    const secureBytes = new Uint8Array(SECURE_BYTE_LENGTH);
    window.crypto.getRandomValues(secureBytes);
    
    const randomHex = Array.from(secureBytes, byte => 
      byte.toString(HEX_RADIX).padStart(HEX_PADDING_LENGTH, '0')).join('');
    
    const timestamp = Date.now().toString();
    return `uid-${timestamp}-${randomHex.substring(0, UID_RANDOM_HEX_LENGTH)}`;
  }
}
